import { createFileRoute } from '@tanstack/react-router';

import { MaterialColumnsPage } from '../../../features/material-columns/material-columns-page';
import { i18n } from '../../../i18n';

// ENG-1035 Settings › Columns › Materials: the Bill of Materials fields and the
// partner's own Materials columns.
export const Route = createFileRoute('/columns/materials/')({
  staticData: {
    permissionSection: 'settings',
    breadcrumb: () => i18n.t('terms.materials', { ns: 'common' }),
  },
  component: MaterialColumnsPage,
});
